import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { AdminapiService } from 'src/app/shared/services/adminapi.service';
import { AppState } from 'src/app/store/app.states';
import { getAdminUserInfo } from 'src/app/store/selector/selector';

declare var bootstrap: any;
declare var $: any;  

@Component({
  selector: 'app-admin-new-video',
  templateUrl: './new-video.component.html',
  styleUrls: ['./new-video.component.scss']
})
export class NewVideoComponent implements OnInit,OnChanges {
  @ViewChild('fileUploader') fileUploader:ElementRef;
  @Input() video:any;
  @Input() modalid:any;
  @Output() newItemEvent = new EventEmitter<string>();
  allskills = [];
  allcategories = [];
  allrules = [];
  alllevels = [];
  skills=[];
  submitting=false;
  user:any
  format:any;
  data = [{ skill: ''}]
  videourl:any="";
  imageurl:any="";
  videofile:any=null;
  imagefile:any=null;
  category:any=0;
  difficulty_rating=0;
  description="";
  formskillsseelcted=[];
  name="";
  formrulesselected=[];
  forminstructionssselected=[];
  formerrorsselected=[];
  formtipsselected=[];
  formnotesselected=[];
  alloptions=[];
  selectedoptions=[];
  scaleFactor:number=0.25;
  Form: FormGroup = this.fb.group({
    name: [this.name, Validators.compose([Validators.required])],
    video: ["", Validators.compose([Validators.required])],
    thumbnail:[""],
    formskills: [],
    formcategory: this.category,
    difficulty_rating: this.difficulty_rating,
    description: this.description,
    formrules: this.fb.array([]),
    forminstructions: this.fb.array([]),
    formerrors:  this.fb.array([]),
    formtips:  this.fb.array([]),
    formnotes:  this.fb.array([]),
    formoptions: this.fb.array([])
  }); 
  editor:any;

  constructor(private fb: FormBuilder,private store: Store<AppState>, private toastrService: ToastrService, public adminApi: AdminapiService) {
  }
  
  onSelectFile(event) {
    const file = event.target.files && event.target.files[0];
    if (file) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      if(file.type.indexOf('image')> -1){
        this.imagefile=file;
        this.format = 'image';
      } else if(file.type.indexOf('video')> -1){
        this.videofile=file;
        this.format = 'video';
      }
      reader.onload = (event) => {
        if(this.format=='video'){
          this.videourl = (<FileReader>event.target).result;
          this.getVideoCover(file)
        }else if(this.format=='image'){
          this.imageurl = (<FileReader>event.target).result;
        }
      }
    }
  }


 getVideoCover(file, seekTo = 3) {
    //console.log("getting video cover for file: ", file);
    return new Promise((resolve, reject) => {
        // load the file to a video player
        const videoPlayer = document.createElement('video');
        videoPlayer.setAttribute('src', URL.createObjectURL(file));
        videoPlayer.load();
        videoPlayer.addEventListener('error', (ex) => {
            reject(ex);
        });
        // load metadata of the video to get video duration and dimensions
        videoPlayer.addEventListener('loadedmetadata', () => {
            // seek to user defined timestamp (in seconds) if possible
            if (videoPlayer.duration < seekTo) {
                reject("video is too short.");
                return;
            }
            // delay seeking or else 'seeked' event won't fire on Safari
            setTimeout(() => {
              videoPlayer.currentTime = seekTo;
            }, 200);
            // extract video thumbnail once seeking is complete
            videoPlayer.addEventListener('seeked', () => {
                //console.log('video is now paused at %ss.', seekTo);
                // define a canvas to have the same dimension as the video
                const canvas = document.createElement("canvas");
                canvas.width = videoPlayer.videoWidth;
                canvas.height = videoPlayer.videoHeight;
                // draw the video frame to canvas
                const ctx = canvas.getContext("2d");
                ctx.drawImage(videoPlayer, 0, 0, canvas.width, canvas.height);
                // return the canvas image as a blob
                let dataURI = canvas.toDataURL('image/jpeg');
                // let a = 
                let boj={
                  canvas:canvas,
                  file:this.dataURLtoFile(dataURI, `${+new Date()}.jpg`),
                  base64:dataURI
                }

                // this.imagefile = boj.file
                // this.imageurl = boj.base64;
                return boj;
                // ctx.canvas.toBlob(
                //     blob => {
                //         resolve(blob);
                //     },
                //     "image/jpeg",
                //     0.75 /* quality */
                // );
            });
        });
    });
}
  // capture() {
  //   let video = document.getElementById('video');
  //         console.log(video)
  //   //let video=document.getElementsByTagName('video');
  //   let w = video.videoWidth * this.scaleFactor;
  //   let h = video.videoHeight * this.scaleFactor;
  //   let canvas = document.createElement('canvas');
  //   canvas.width = w;
  //   canvas.height = h;
  //   let ctx = canvas.getContext('2d');
  //   ctx.drawImage(video, 0, 0, w, h);
  //   let dataURI = canvas.toDataURL('image/jpeg');
  //   // let a = 
  //   let boj={
  //     canvas:canvas,
  //     file:this.dataURLtoFile(dataURI, `${+new Date()}.jpg`),
  //     base64:dataURI
  //   }
  //   return boj;
  // }

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime, lastModified:new Date().getTime() });
  }

  getThumbUrl(url : string){
    return  "assets/images/"+url
  }

  getVideoUrl(url : string){
    return  "assets/videos/"+url
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.formskillsseelcted=[];
    this.formrulesselected=[];
    this.name="";
    this.category=0;
    this.forminstructionssselected=[];
    this.formerrorsselected=[];
    this.formtipsselected=[];
    this.formnotesselected=[];
    this.description="";
    this.videourl=null;
    this.alloptions=[];
    this.imageurl=null;
    setTimeout( ()=> { 
      $('.selectpicker').selectpicker('refresh');
    }, 100); 
    if(this.video){
      this.formskillsseelcted = this.video.allskills;
      this.formrulesselected=this.video.rules;
      this.name=this.video.name;
      this.category=this.video.cate_id;
      this.forminstructionssselected=this.video.instructions;
      this.formerrorsselected=this.video.errors;
      this.formtipsselected=this.video.legalitytips;
      this.formnotesselected=this.video.othernotes;
      this.description=this.video.description;
      this.videourl=this.getVideoUrl(this.video.videothumb);
      this.imageurl=this.getThumbUrl(this.video.thumbnail);
      this.alloptions=this.video.alloptions;
      this.difficulty_rating=this.video.difficulty_rating;
      //this.getLevelRules(this.level.id)
    }
    this.initForm()
  }

  ngOnInit()  
  {    
    setTimeout(()=>{
      this.getUserData()
      this.getVideoFormData()
    },500)
    $(document).ready(() => {   
        setTimeout( ()=> { 
           $('.selectpicker').selectpicker('refresh');
        }, 500); 
    });  
  } 

  addNewItem(value: string) {
    this.newItemEvent.emit(value);
  }

  get formoptions() : FormArray {
    return (this.Form.controls["formoptions"] as FormArray);
  }

  public get formoptionsControls() {
      return (this.Form.controls["formoptions"] as FormArray).controls as FormGroup[];
  }

  
  get formrules() : FormArray {
    return (this.Form.controls["formrules"] as FormArray);
  }

  addRule() {
    (this.Form.controls["formrules"] as FormArray).push(this.fb.group({
      rule: [null, Validators.required],
      level: [null, Validators.required]
    }))
    setTimeout( ()=> { 
      $('.selectpicker').selectpicker('refresh');
    }, 200); 
  }
  
  deleteformrules(formruleIndex: number) {
    this.formrules.removeAt(formruleIndex);
  } 

  get formerrors() : FormArray {
    return (this.Form.controls["formerrors"] as FormArray);
  }

  deleteformerrors(formruleIndex: number) {
    this.formerrors.removeAt(formruleIndex);
  }

  addErrors() {
    (this.Form.controls["formerrors"] as FormArray).push(this.fb.group(
      {error:["", Validators.compose([Validators.required])]}
      ))
    setTimeout( ()=> { 
      $('.selectpicker').selectpicker('refresh');
    }, 200); 
  } 

  get formtips() : FormArray {
    return (this.Form.controls["formtips"] as FormArray);
  }

  deleteformtips(formruleIndex: number) {
    this.formtips.removeAt(formruleIndex);
  }

  addTips() {
    (this.Form.controls["formtips"] as FormArray).push(this.fb.group(
      {tip:["", Validators.compose([Validators.required])]}
      ))
    setTimeout( ()=> { 
      $('.selectpicker').selectpicker('refresh');
    }, 200); 
  } 

  get formnotes() : FormArray {
    return (this.Form.controls["formnotes"] as FormArray);
  }

  deleteformnotes(formruleIndex: number) {
    this.formnotes.removeAt(formruleIndex);
  }

  addNotes() {
    (this.Form.controls["formnotes"] as FormArray).push(this.fb.group(
      {note:["", Validators.compose([Validators.required])]}
      ))
    setTimeout( ()=> { 
      $('.selectpicker').selectpicker('refresh');
    }, 200); 
  } 

  get forminstructions() : FormArray {
    return (this.Form.controls["forminstructions"] as FormArray);
  }

  deleteforminstructions(formruleIndex: number) {
    this.forminstructions.removeAt(formruleIndex);
  }

  addInstructions() {
    (this.Form.controls["forminstructions"] as FormArray).push(this.fb.group(
      {instruction:["", Validators.compose([Validators.required])]}
      ))
    setTimeout( ()=> { 
      $('.selectpicker').selectpicker('refresh');
    }, 200); 
  } 

  getUserData(){
    this.store.pipe(select(getAdminUserInfo)).subscribe(data=>{
      this.user = data
    },error=>{
      this.toastrService.error("unable to handle response");
    })
  }
  
  getVideoFormData(){
    this.adminApi.setLoader(true)
    this.adminApi.getVideoFormData().subscribe((data: any) => {
      this.allskills = data.skills
      this.allcategories = data.categories
      this.allrules = data.rules
      this.alllevels = data.levels
      setTimeout( ()=> { 
        $('.selectpicker').selectpicker('refresh');
      }, 600); 
      this.adminApi.setLoader(false)
    },error=>{
      this.adminApi.setLoader(false)
      this.toastrService.error("unable to handle response");
    })
  }

  initForm(){
    this.Form = this.fb.group({
      name: [this.name, Validators.compose([Validators.required])],
      video: ["", !this.video?Validators.compose([Validators.required]):null],
      thumbnail: [""],
      formskills: [this.formskillsseelcted],
      formcategory: this.category,
      difficulty_rating: this.difficulty_rating,
      description: this.description,
      formrules: this.fb.array([]),
      forminstructions: this.fb.array([]),
      formerrors:  this.fb.array([]),
      formtips:  this.fb.array([]),
      formnotes:  this.fb.array([]),
      formoptions:this.fb.array([])
    });
    
    for(let item in this.formrulesselected) {
      (this.Form.controls["formrules"] as FormArray).push(this.fb.group({
        rule: [this.formrulesselected[item]['rule'], Validators.required],
        level: [this.formrulesselected[item]['level'], Validators.required]
      }))
    }
    
    for(let item in this.forminstructionssselected) {
      (this.Form.controls["forminstructions"] as FormArray).push(this.fb.group({
        instruction: [this.forminstructionssselected[item]['instruction'], Validators.required]
      }))
    }
    
    for(let item in this.formerrorsselected) {
      (this.Form.controls["formerrors"] as FormArray).push(this.fb.group({
        error: [this.formerrorsselected[item]['error'], Validators.required]
      }))
    }
    
    for(let item in this.formtipsselected) {
      (this.Form.controls["formtips"] as FormArray).push(this.fb.group({
        tip: [this.formtipsselected[item]['tip'], Validators.required]
      }))
    }
    
    for(let item in this.formnotesselected) {
      (this.Form.controls["formnotes"] as FormArray).push(this.fb.group({
        note: [this.formnotesselected[item]['note'], Validators.required]
      }))
    }

    for(let item in this.alloptions) {
      (this.Form.controls["formoptions"] as FormArray).push(this.fb.group({
        option: [this.alloptions[item]['option_id'], Validators.required],
        choice: [this.alloptions[item]['choice_value'], Validators.required]
      }))
    }

    if(this.editor){
      this.editor.setContent(this.description);
    }
    setTimeout( ()=> { 
      $('.selectpicker').selectpicker('refresh');
    }, 100); 
  }

  changeCategory(event){
    let cat = event?.target?.value
    let params = {}
    if(this.video){
      params = {
        video_id:this.video.id,
        cat_id:cat
      }
    }else{
      params = {
        cat_id:cat
      }
    }
    if(!cat){
      (this.Form.controls["formoptions"] as FormArray).clear();
      this.alloptions=[];
      return
    }
    this.adminApi.setLoader(true)
    this.adminApi.getSelectedCatOptions(params).subscribe((data: any) => {
      if (data.success) {
        (this.Form.controls["formoptions"] as FormArray).clear();

        this.alloptions=data.alloptions;
        
        for(let item in this.alloptions) {
          (this.Form.controls["formoptions"] as FormArray).push(this.fb.group({
            option: [this.alloptions[item]['option_id'], Validators.required],
            choice: [this.alloptions[item]['choice_value'], Validators.required]
          }))
        }
        setTimeout( ()=> { 
          $('.selectpicker').selectpicker('refresh');
        }, 100); 
        this.adminApi.setLoader(false)
        //this.webApi.setSession(data);
        //this.router.navigateByUrl('/');
      } else {
        this.toastrService.error(data.message);
        this.adminApi.setLoader(false)
      }
    },
    error => {
      this.toastrService.error("unable to handle response");
      this.adminApi.setLoader(false)
    });
    
  }

  handleEvent($event){
    if(!this.editor){
      this.editor=$event.editor
    }
  }

  onSubmit(form: FormGroup) {
    if (form.valid && !this.submitting) {
      this.submitting = true;
      if(this.video){
        form.value.id=this.video.id
      }else{
        form.value.id="";
      }
      // if(!this.imageurl){
      //   this.toastrService.error("please select image");
      //   return
      // }
      const formData = new FormData();
      formData.append('id',form.value.id);
      formData.append('name', form.value.name);
      formData.append('video', this.videofile);
      formData.append('thumbnail', this.imagefile);
      formData.append('formskills', JSON.stringify(form.value.formskills));
      formData.append('formrules', JSON.stringify(form.value.formrules));
      formData.append('formoptions', JSON.stringify(form.value.formoptions));
      formData.append('formcategory', form.value.formcategory);
      formData.append('difficulty_rating', form.value.difficulty_rating);
      formData.append('description', form.value.description);
      formData.append('forminstructions', JSON.stringify(form.value.forminstructions));
      formData.append('formerrors', JSON.stringify(form.value.formerrors));
      formData.append('formtips', JSON.stringify(form.value.formtips));
      formData.append('formnotes', JSON.stringify(form.value.formnotes));
      this.adminApi.addVideo(formData).subscribe((data: any) => {
        if (data.success) {
          this.addNewItem('change')
          this.videofile="";
          this.fileUploader.nativeElement.value = null;
          if(!this.video){
            form.reset();
            $('.selectpicker').selectpicker('refresh');
          }
					this.toastrService.success(data.message);
          $('#'+this.modalid).modal('hide');
          //this.webApi.setSession(data);
          //this.router.navigateByUrl('/');
        } else {
					this.toastrService.error(data.message);
        }
        this.submitting = false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.submitting=false;
      });
    } else {
      form.markAllAsTouched();
    }
  }

  get f2(): { [key: string]: AbstractControl } {
    return this.Form.controls;
  }
  
}
